import { DeepCopy } from "./DeepCopy";
import { getAvarege } from "./getAvarege";
import UserDefaultObject from "./UserDefaultObject";

const getRate = rate => {
  const arr = new Array();
  for (const item of rate) {
    arr.push(item.rate);
  }
  return getAvarege(arr);
};

const getGoodOrBad = gobObject => {
  const gob = [...UserDefaultObject.goodOrBad];
  for (const row of gob) {
    for (const item of gobObject) {
      if (row.name === item.name) {
        row.value = item.value;
      }
    }
  }
  return gob;
};

export const initUserObjectRating = (rate, obj, allProduct) => {
  rate.map(item => (item.rate = 0));
  const newRate = obj.rate ? getRate(obj.rate) : 0;
  const newObj = {
    ...obj,
    recommend: obj.recommend === 1 ? true : false,
    rate: newRate,
    goodOrBad: getGoodOrBad(obj.goodOrBad),
    allProduct: allProduct ? allProduct : []
  };
  const userInfo = DeepCopy(newObj);
  const dubleUserInfo = DeepCopy(newObj);
  return { userInfo, dubleUserInfo };
};
